export function pickEs(value: unknown): string {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object') {
    const v = value as { es?: unknown; en?: unknown; pt?: unknown };
    if (typeof v.es === 'string') return v.es;
    if (typeof v.en === 'string') return v.en;
    if (typeof v.pt === 'string') return v.pt;
  }
  return '';
}
